export default __webpack_public_path__ + "static/media/Netatmo.953a7dc4.png";